export const eventTracker = (category, action, label) => {
  window.gtag("event", "click", {
    action: action,
    label: label,
    category: category,
  });
};

export const purchaseEvent = (bookedTickets) => {
  // Send at most once per transaction_id (also protects the GTM-driven
  // Google Ads conversion, which triggers off this same dataLayer event).
  try {
    if (bookedTickets && bookedTickets.transaction_id) {
      var key = "ga4_purchase_sent_" + bookedTickets.transaction_id;
      if (window.sessionStorage.getItem(key)) return;
      window.sessionStorage.setItem(key, "1");
    }
  } catch (e) {
    // sessionStorage unavailable (private mode/quota): fall through and send
  }
  window.gtag("event", "purchase", bookedTickets);

  // OpenAI Ads conversion (TRIP-158). Covered by the same once-per-transaction
  // guard above; event_id (order UUID) dedupes against the server-side
  // Conversions API event. amount is in minor units (cents).
  if (window.oaiq) {
    window.oaiq(
      "measure",
      "order_created",
      {
        type: "contents",
        amount: Math.round((bookedTickets.value || 0) * 100),
        currency: bookedTickets.currency || "USD",
      },
      { event_id: bookedTickets.event_id || bookedTickets.transaction_id }
    );
  }
};